import router from './router';
import store from './store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import {
    getToken,
    getUserId,
    removeToken,
    removeUserId
} from '@/library/js/auth.js';
import {
    findUserAppAndMenu,
    renderAppsData,
    composeAllAppMenuList,
    renderRouterByMenu,
    composeAllRoutesList
} from "./util/menu";
import {
    registerAppByUser,
    setDefaultApp,
    startApp,
    firstMountedCallback
} from "./util/qiankun";
/**
 * @name 导入无需服务端获取的微应用
 */
import noAuthApps from "./util/appConfig";
import {
    valInDeep,
    multiplevalInDeep
} from '@/library/js/array.js';
import {
    setCookie,
    getCookie
} from '@/library/js/cookie.js';
import Cookies from "js-cookie";

NProgress.configure({
    showSpinner: false
});

const whiteList = [
    '/freelogin',
    '/thirdoauth',
    '/outside/active',
    '/outside/fillinformation',
    '/outside/findPassword',
    '/outside/schoolinfosearch',
    '/outside/sxschoolinfosearch'
];
//兼容端未集成sso的免登陆地址
// const list = ['/homework/cloudExamIndex', '/auth/applist'];
const list = process.env.VUE_APP_CHANNEL === "nanjing" ? ['/homework/cloudExamIndex', '/auth/applist', '/auth/productlist', '/auth/manageproduct','/auth/nanjingAuth'] : ['/homework/cloudExamIndex', '/base/schoolMain'];
let loadFirst = false;

router.beforeEach((to, from, next) => {
    // let appType = Cookies.get('appType')
    let appType =sessionStorage.getItem('appType')

    if (to.query.appType) {
        appType = Number(to.query.appType);
        // Cookies.set('appType', appType);
        sessionStorage.setItem('appType', appType)
    }

    NProgress.start();
    if (whiteList.indexOf(to.path) !== -1) {
        debugger;
        if (to.path.indexOf(noAuthApps[0].route_prefix) !== -1) {
            if (loadFirst) {
                next();
                NProgress.done();
            } else {
                let registAppData = renderAppsData(noAuthApps, [], []);
                //注册子项目
                registerAppByUser(registAppData);
                // 设置默认子应用
                setDefaultApp('/' + noAuthApps[0].route_prefix);
                //启动微服务
                startApp();

                firstMountedCallback(() => {
                    loadFirst = true;
                    next();
                    NProgress.done();
                });
            }
        } else {
            next();
        }
    } else {
        debugger;
        //登录根据token来判断  需要加载的子应用和菜单权限根据store值来判断 有直接注册并加载默认第一个 无需要重新获取
        //判断是否有token
        const hasToken = getToken();
        //有token 判断路径是否未登录 是：直接跳转至登录页 否：需要判断用户权限
        //端跳转过来未兼容的地址（排除同地址但是后台切换的情况）
        let isCheck = !(list.indexOf(to.path) > -1 && !ssoClient.getUserInfo().id);
        ssoClient.check(process.env.VUE_APP_APPID, isCheck);
        // const userInfo = ssoClient.getUserInfo();
        // const userId = userInfo.id;
        const token = ssoClient.getCookie();

        // 这里为了兼容各端没有集成oss，跳转免登录地址的情况
        if (token || hasToken) {
            //根据用户id获取用户权限（包含子应用和子应用的菜单）
            const hasApps = store.getters.apps && store.getters.apps.length > 0;
            if (hasApps) {
                next()
            } else {
                let curUserId = getUserId();
                try {
                    //获取用户权限
                    let userParam = {
                        // userId: userId || curUserId,
                        token:token || hasToken,
                        // userId: curUserId,
                        isSaveCookie: false
                    };
                    if (process.env.VUE_APP_CHANNEL === "nanjing") {
                        userParam.userId = curUserId;
                    }
                    if (appType == 1) {
                        userParam.appType = appType;
                    }
                    store.dispatch('user/getUserInfo', userParam).then((res) => {
                        //根据用户id 获取用户权限（应用和应用的菜单）
                        let userMenuParam = {
                            userId: res.data.id || curUserId,
                            // userId:curUserId,
                            adminType: store.getters.adminType,
                            userType: store.getters.userType,
                        };
                        if (process.env.VUE_APP_CHANNEL === "nanjing") {
                            userMenuParam.userId = curUserId;
                        }
                        if (appType == 1) {
                            userMenuParam.appType = appType;
                        }
                        findUserAppAndMenu(userMenuParam, () => {
                            //项目集合
                            let projects = store.getters.projects;
                            //应用集合
                            let apps = store.getters.apps;
                            //所有应用的菜单
                            let allAppMenuList = composeAllAppMenuList(apps);
                            // 有权限的路由
                            // let allRoutesList = composeAllRoutesList(projects, allAppMenuList);
                            let registAppData = renderAppsData(projects, apps, allAppMenuList);
                            //注册子项目
                            registerAppByUser(registAppData);

                            //根据当前路由path获取要加载的子项目、应用、菜单    （如果是根路径默认获取第一个菜单）
                            let defaultOpenedsArr = [];
                            // let path = to.path.substring(findIndex(to.path, '/', 1), to.path.length);
                            // //根据当前路径遍历路由集合
                            // let targetMenu = valInDeep(allRoutesList, path, 'path', 'children');

                            //根据当前路径遍历菜单集合
                            let targetMenu = multiplevalInDeep(allAppMenuList, to.path, '/', 'module', 'path', 'children');

                            let defaultProjectRP = '',
                                defaultAppId = '',
                                defaultPath = '',
                                defaultPathOpenMode = 0;
                            if (targetMenu.length > 0 && targetMenu[0].path != '') {
                                let curMenu = multiplevalInDeep(allAppMenuList, targetMenu[0].path, '/', 'module', 'path', 'children');
                                if (curMenu.length > 0 && curMenu[0].path != '')
                                    defaultOpenedsArr.push(targetMenu[0].parentId);
                                store.dispatch("menu/setSelectedMenuId", targetMenu[0].id);
                                defaultProjectRP = targetMenu[0].module;
                                defaultAppId = targetMenu[0].appId;
                                defaultPath = to.path;

                                // 通过menuId 查找菜单，设置默认展开菜单
                                // let curMenu = valInDeep(allAppMenuList, targetMenu[0].meat.menuId, 'id', 'children');
                                // if (curMenu.length > 0 && curMenu[0].path != '')
                                //     defaultOpenedsArr.push(curMenu[0].parentId);
                                // // 设置默认选中菜单
                                // store.dispatch("menu/setSelectedMenuId", targetMenu[0].meat.menuId);
                                // // 默认子应用
                                // defaultProjectRP = targetMenu[0].meat.module;
                                // // 默认应用id
                                // defaultAppId = targetMenu[0].meat.appId;
                                // // 默认路径
                                // defaultPath = to.path;
                            } else {
                                defaultProjectRP = allAppMenuList[0].module;
                                defaultAppId = allAppMenuList[0].appId;
                                defaultPath = '/' + defaultProjectRP;
                                defaultPath += allAppMenuList[0].path || allAppMenuList[0].children[0].path;
                            }
                            store.dispatch("menu/setOpenedSubmenuArr", defaultOpenedsArr);
                            //设置默认应用
                            if (defaultAppId) {
                                let defaultApp = apps.filter(
                                    item => item.id === defaultAppId
                                )[0];
                                if (defaultApp) {
                                    store.dispatch("menu/setSelectedApp", defaultApp);
                                    let defaultAppMenusData = renderRouterByMenu(defaultApp.menuTreeList, true);
                                    store.commit('menu/SET_MENUS', defaultAppMenusData);
                                }
                            }
                            // 设置默认子应用
                            setDefaultApp(defaultProjectRP);

                            //启动微服务
                            startApp();
                            next({
                                path: defaultPath,
                                query: to.query,
                                replace: true
                            });
                        });
                    }).catch(res => {
                        // 移除token并跳转至登录页
                        store.dispatch('user/resetToken').then(() => {
                            ssoClient.login(
                                process.env.VUE_APP_APPID
                            );
                            NProgress.done();
                        });
                    });
                } catch (error) {
                    // 移除token并跳转至登录页
                    store.dispatch('user/resetToken').then(() => {
                        ssoClient.login(
                            process.env.VUE_APP_APPID
                        );
                        NProgress.done();
                    });
                }
            }
        } else {
            let registAppData = renderAppsData(noAuthApps, [], []);
            //注册子项目
            registerAppByUser(registAppData);
            // 设置默认子应用
            setDefaultApp('/' + noAuthApps[0].route_prefix);
            //启动微服务
            startApp();

            firstMountedCallback(() => {
                loadFirst = true;
                ssoClient.login(
                    process.env.VUE_APP_APPID
                );
            });
        }
    }
});

router.afterEach(() => {
    NProgress.done();
});

function findIndex(str, cha, num) {
    var x = str.indexOf(cha);
    for (var i = 0; i < num; i++) {
        x = str.indexOf(cha, x + 1);
    }
    return x;
}